
import { defineComponent } from "vue";
import GameService from "@/services/GameService";
import ResponseData from "@/_models/ResponseData";
import { Helper } from "@/utils/Helper";
import store from "@/store/index";
import gamesListGameBoxComponent from '@/modules/games/components/gamesListGameBoxComponent.vue';

export default defineComponent({
  name: "viewGamesList",
  data: function () {
    return {
      games: [],
      testnetGames: [],
      mainnetGames: [],
      mainnetGameTitles: [],
      userData: store.getters["auth/user"] ?? "",
      showLoader: false,
      currentTab: 'all',
    };
  },
  components: {
    gamesListGameBoxComponent
  },
  methods: {
    openCreateGameModal() {
      this.emitter.emit('OPEN_CREATE_NEW_GAME_MODAL', true);
    },
    getGameList() {
      this.showLoader = true;
      if (this.userData !== "") {
        GameService.getGameListByWalletAddress(this.userData.testnetWalletAddress, 'testnet')
          .then((response: ResponseData) => {
            if (response.status === 200) {
              this.games = response.data;
              let scope = this;
              this.games.forEach(function (game: any) {
                game.newExpiryFormat = Helper.formatDate(game.expiry);
                game.isExpiring = Helper.checkNamespace(game.expiry);
                if(game.status == 3){
                  scope.testnetGames.push(game);
                }
              });
            }
            this.showLoader = false;
          })
          .catch((error) => {
            this.showLoader = false;
            console.log(error)
            Helper.endpointErrorHandling(error, "You have not connected your wallet yet.", "warning");
          });
        if(this.userData.mainnetWalletAddress){
          GameService.getGameListByWalletAddress(this.userData.mainnetWalletAddress, 'mainnet')
            .then((response: ResponseData) => {
              if (response.status === 200) {
                this.mainnetGames = response.data;
                let scope = this;
                this.mainnetGames.forEach(function (game: any) {
                  game.newExpiryFormat = Helper.formatDate(game.expiry);
                  game.isExpiring = Helper.checkNamespace(game.expiry);
                  scope.mainnetGameTitles.push(game.title);
                });
              }

              this.showLoader = false;
            })
            .catch((error) => {
              this.showLoader = false;
              // Helper.endpointErrorHandling(error, "You have not connected your wallet yet.", "warning");
            });
        }
      }
    },
  },
  mounted() {
    this.getGameList();
  },

  computed: {
    isGameCreated() {
      return store.getters["game/createdGame"];
    },
    testnetLabel() {
      return store.getters['config/configTestnetLabel'];
    },
    mainnetLabel() {
      return store.getters['config/configMainnetLabel'];
    },
    assetUrl() {
      return store.getters['config/assetUrl'];
    },
  },

  watch: {
    isGameCreated() {
      if (store.getters["game/createdGame"] === "1") {
        this.getGameList();
        store.dispatch("game/addGame", "0");
      }
    },
  },
});
